export default () => jQuery(($) => {

	function getUrlParameter(name, url = window.location.search) {
		if (url !== window.location.search) {
			url = new URL(url).search.slice(1);
		}
		let searchParams = new URLSearchParams(url)
		if (searchParams.has(name)) {
			return searchParams.get(name);
		}
		else {
			return null;
		}
	}

	function loadAjax(state) {
		if (state.ajaxHref) {
			$.ajax({
				url: state.ajaxHref,
			}).done((data) => {
				$(`.imageGallery[data-ajax-gallery-index="${state.galleryIndex}"]`)
					.replaceWith(data)
					.attr('aria-live', 'polite').attr('tabindex', '-1')
					.focus();

				initAjax();
			});
		}
	}

	function initAjax() {
		$('.imageGallery a[data-ajax-href]').click(function (e) {
			// replace page URL
			if (typeof (history.pushState) !== 'undefined') {
				e.preventDefault();
				e.stopImmediatePropagation();
				const currentPage = window.location.href.split(/[?#]/)[0];
				const ajaxHref = $(this).attr('data-ajax-href');
				const galleryIndex = getUrlParameter('gallery_index', ajaxHref);

				if (getUrlParameter('action', ajaxHref) === 'image_gallery') {
					const url = (getUrlParameter('gallery_page', ajaxHref)) ?
						`${currentPage}?gallery_page=${getUrlParameter('gallery_page', ajaxHref)}&gallery_index=${galleryIndex}` :
						`${currentPage}?gallery_index=${galleryIndex}`;
					history.pushState({ajaxHref, galleryIndex}, null, url);
				} else if (getUrlParameter('action', ajaxHref) === 'image_gallery_zoom') {
					history.pushState({ajaxHref, galleryIndex}, null, `${currentPage}?gallery_image=${getUrlParameter('image_id', ajaxHref)}&gallery_index=${galleryIndex}`);
				}

				return false;
			}

			return true;
		});

		$(window).on('popstate', (e) => {
			if (e.originalEvent.state && e.originalEvent.state.ajaxHref) {
				loadAjax(e.originalEvent.state);
			}
		});
	}

	// overwrite history.pushState so that it also calls the loadAjax function when called
	(function (original) {
		history.pushState = function (state) {
			if (!history.state || (history.state && history.state.galleryIndex !== state.galleryIndex)) {
				history.replaceState({
						ajaxHref: $(`.imageGallery[data-ajax-gallery-index="${state.galleryIndex}"]`).attr('data-ajax-start'),
						galleryIndex: state.galleryIndex,
					},
					null,
					window.location.href);
			}
			loadAjax(state);
			return original.apply(this, arguments);
		};
	}(history.pushState));

	// launch routines
	initAjax();
});
